import React, { useRef } from "react";
import styled, { createGlobalStyle } from "styled-components";
import Slider from "react-slick";
import QuickPinchZoom, { make3dTransformValue } from "react-quick-pinch-zoom";
import * as Assets from "../../../utils/svg_assets";
import ApiUtils from "../../../utils/api_utils";

const Wrapper = styled.div`
  min-height: 0;
  min-width: 0;

  background: black;
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 10;
  top: 0;
  height: 100vh;

  display: flex;
  justify-content: center;
  align-items: center;

  .zoom-container {
    .slider-wrapper {
      .slick-arrow {
        visibility: visible;
        opacity: 1;
        transition: visibility 0.15s linear, opacity 0.15s linear;

        top: 50%;

        img {
          background: #ffffff80;
          border-radius: 50%;
          width: 15px;
          height: 15px;
          padding: 10px;
          stroke: #7f7f7f;
          path {
            stroke-width: 3px;
          }
        }
      }

      .slick-prev {
        z-index: 1;
        left: 15px;
        &:before {
          display: none;
        }
      }

      .slick-next {
        right: 40px;

        &:before {
          display: none;
        }
      }

      .slick-track {
        .zoom-image {
          max-width: 100%;
        }

        .slick-slide {
          height: auto;
          width: 100%;

          > div {
            height: 100%;
            background: #f6f8fa;
          }
        }
      }
    }
  }
`;

const GlobalStyle = createGlobalStyle`
* {
  min-height: 0;
  min-width: 0;
}
`;

const ZoomImageModal = ({ open, toggle, data }) => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    dotsClass: "slick-dots bottom-dots",
    responsive: [
      {
        breakpoint: 992,
        settings: {
          arrows: true,
          dots: true,
        },
      },
    ],
  };

  return (
    <TransitionWrapper className={open ? "open" : ""}>
      <Wrapper open={open}>
        <div className="container-modal" id="pdp-mobile-modal">
          <div className="container">
            <CloseButtonContainer>
              <button className="close-button" onClick={toggle}>
                <img src={Assets.iconClose} alt="Icon Close" />
              </button>
            </CloseButtonContainer>
            <div className="zoom-container">
              <PinchOnImage open={open} />

              <div className="slider-wrapper no-container">
                <Slider {...settings}>
                  {data &&
                    data.map((item, index) => {
                      return (
                        <Slide
                          key={index}
                          url={ApiUtils.validateImgUrl({
                            url: item?.images?.img?.display,
                          })}
                        />
                      );
                    })}
                </Slider>
              </div>
            </div>
          </div>
        </div>
      </Wrapper>
      {open && <GlobalStyle />}
    </TransitionWrapper>
  );
};

export default ZoomImageModal;

const TransitionWrapper = styled.div`
  background: rgba(0, 0, 0, 0.5);
  transition: all ease 0.4s;
  pointer-events: none;
  opacity: 0;

  &.open {
    opacity: 1;
    pointer-events: auto;
  }
`;

const CloseButtonContainer = styled.div`
  padding: 10px;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  width: 100%;
  .close-button {
    cursor: pointer;
    background: transparent;
    border: none;

    &:focus {
      outline: none;
      border: none;
    }
    img {
      width: 15px;
      height: 15px;
    }
  }
`;

const Slide = (props) => {
  const imgRef = useRef(null);
  const quickPinchZoomRef = useRef(null);

  const onUpdate = ({ x, y, scale }) => {
    const { current: img } = imgRef;

    if (img && img.complete) {
      const value = make3dTransformValue({ x, y, scale });
      img.style.setProperty("transform", value);
      img.style.opacity = 1;
    } else if (img) {
      const value = make3dTransformValue({ x: 0, y: 0, scale: 1 });
      img.style.setProperty("transform", value);
      img.style.opacity = 0;
    }
  };

  return (
    <QuickPinchZoom
      onUpdate={onUpdate}
      ref={quickPinchZoomRef}
      draggableUnZoomed={false}
      shouldInterceptWheel={() => false}
    >
      <div className="centered bg-black">
        <img
          className="zoom-image product-image"
          src={props.url}
          alt="zoomed-item"
          ref={imgRef}
        />
      </div>
    </QuickPinchZoom>
  );
};

const PinchOnImageWrapper = styled.div`
  /* width: 100%;
  height: 100%; */
  /* background: red; */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
  position: absolute;
  top: calc(50% - 40px);
  left: 50%;
  transform: translate(-50%, 0);

  transition: visibility 4s linear, opacity 4s linear;
  visibility: ${({ open }) => (open ? "hidden" : "visible")};

  .pinch-image-container {
    background: #ffffff52;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 10px;

    img {
      width: 45px;
      height: auto;
    }
  }
`;

const PinchOnImage = ({ open }) => {
  return (
    <PinchOnImageWrapper open={open}>
      <div className="pinch-image-container">
        Pinch on the image{" "}
        <img
          src="https://theinside.imgix.net/icons/pinch_zoom_icon.svg"
          alt="pinch icon"
        />
      </div>
    </PinchOnImageWrapper>
  );
};
